// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__33fN2","content":"styles_content__u6Z7h","checkbox":"styles_checkbox__z2c5w","checkboxLabel":"styles_checkboxLabel__1waru"};